import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export function getButtonPermissions(id) {
  return Axios({
    url: requestPrefix.centerUrl + '/sys/operation/getButtonPermissions',
    method: 'get',
    params: { projectId: id }
  })
}

export default {
  // 获取用户列表
  pageListUser(params) {
    return Axios({
      url: '/system/userProject/selectProjectUser',
      method: 'post',
      data:params
    })
  },
  // 获取用户列表(督导检查)
  pageListUserLeaderCheck(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/sys/user/pageUserLeaderCheck',
      method: 'get',
      params
    })
  },
  // 获取用户列表
  pageListCheckUser(params) {
    return Axios({
      url:'/system/userProject/selectProjectUser',
      method: 'post',
      data: params
    })
  },
  // 获取区域列表
  projectAreaType(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectAreaType/list',
      method: 'get',
      params: params
    })
  },
  // 设备类型
  listType() {
    return Axios({
      url: requestPrefix.projectUrl + '/faceDevice/getListType',
      method: 'get'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/user/index.js